import React, { useEffect, useState } from "react"
import { createConsumer, Consumer } from "@rails/actioncable"
import { useSelector } from "react-redux"
import { getUserSession } from "../../selectors/user"
import { CableContext } from "./CableContext"

interface Props {
  children?: React.ReactNode
}

const CableProvider: React.FC<Props> = ({ children }) => {
  const session = useSelector(getUserSession)
  const apiToken = session?.apiToken
  const [consumer, setConsumer] = useState<Consumer | null>(null)

  useEffect(() => {
    if (!apiToken) {
      if (consumer) {
        consumer.disconnect()
        setConsumer(null)
      }
      return
    }

    const url = `${process.env.ACTION_CABLE_URL}?token=${apiToken}`
    const newConsumer = createConsumer(url)
    setConsumer(newConsumer)

    return () => {
      newConsumer.disconnect()
    }
  }, [apiToken])

  return (
    <CableContext.Provider value={{ apiToken, consumer }}>
      {children}
    </CableContext.Provider>
  )
}

export default CableProvider
